/* POGO: muted hosted-video playback in the visible product gallery. External videos keep Horizon's controls. */
(() => {
  if (window.pogoProductVideoInstalled) return;
  window.pogoProductVideoInstalled = true;
  const states = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }
  function scan() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.closest('dialog')) return;
      gallery.querySelectorAll('deferred-media').forEach((media) => {
        if (media.closest('dialog')) return;
        const container = media.closest('slideshow-slide, .media-gallery__grid > li, .product-media-container');
        if (!container) return;
        const slide = media.closest('slideshow-slide');
        const visible = media.getClientRects().length > 0;
        const active = visible && !document.hidden && (!slide || slide.getAttribute('aria-hidden') === 'false' ||
          (slide.getAttribute('aria-hidden') === null && slide.parentElement?.querySelectorAll('slideshow-slide').length === 1));
        const state = states.get(media) || { active: false, video: null, userPaused: false };
        states.set(media, state);
        let videos = [...media.querySelectorAll('video')];
        let video = videos.at(-1);
        const hostedTemplate = media.querySelector('template')?.content.querySelector('video');
        if (!video && !hostedTemplate) return;
        if (!active) {
          videos.forEach((item) => item.pause());
          state.active = false;
          state.userPaused = false;
          return;
        }
        if (reducedMotion.matches) return;
        if (!video && typeof media.loadContent === 'function') {
          media.loadContent(false);
          videos = [...media.querySelectorAll('video')];
          video = videos.at(-1);
        }
        if (!video) return;
        if (state.active && state.video === video) return;
        state.active = true;
        state.video = video;
        videos.filter((item) => item !== video).forEach((item) => item.pause());
        video.muted = true;
        video.playsInline = true;
        if (state.userPaused) return;
        video.play().then(() => {
          if (!media.isConnected || !state.active || document.hidden) { video.pause(); return; }
          media.isPlaying = true;
          media.updatePlayPauseHint?.(true);
          media.querySelector('[ref="deferredMediaPlayButton"]')?.classList.add('deferred-media__playing');
        }).catch(() => { /* Leave Horizon's play control available if autoplay is denied. */ });
      });
    });
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('[ref="toggleMediaButton"]');
    const media = control?.closest('media-gallery deferred-media');
    const state = media && states.get(media);
    if (state?.video) state.userPaused = !state.video.paused;
  }, true);
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule);
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) document.querySelectorAll('media-gallery video').forEach((video) => video.pause());
    schedule();
  });
  customElements.whenDefined('deferred-media').then(schedule);
  schedule();
})();
